import { Plan } from '../../resources/stripe/types'

export enum StripeActionTypes {
    SET_PLANS = 'stripe/SET_PLANS',
}

export interface StripeState {
    plans?: Array<Plan>
}
